import "./App.scss";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import GameSelect from "./components/UI/GameSelect/GameSelect";
import Level from "./components/UI/Level/Level";
import FriendPlay from "./views/FriendPlay";
import GameScene from "./views/GameScene";
import MatchPlay from "./views/MatchPlay";
import Orientation from "./components/UI/Orientation/Orientation";
import Connect from "./components/UI/Connect/Connect";
import Play from "./components/UI/Play/Play";
import Start from "./components/UI/Start/Start";
import Ranking from "./components/UI/Ranking/Ranking";
import './css/style.css'
import { useRef } from 'react';
import { getCountryName, sendTelegramMessage, ensureUuid } from './utils/telemetry';

function App() {
  const [orientation, setOrientation] = useState(false);
  const sentOnceRef = useRef(false);

  // Get country info from geolocation and push value in firebase
  // useEffect(() => {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         const { latitude, longitude } = position.coords;
  //         fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`)
  //           .then(response => response.json())
  //           .then(data => {
  //             const country = data.address && data.address.country ? data.address.country : "Unknown";
  //             // INSERT_YOUR_CODE
  //             // Generate a uuid if not present in localStorage
  //             let uuid = localStorage.getItem('uuid');
  //             if (!uuid) {
  //               uuid = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
  //                 (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  //               );
  //               localStorage.setItem('uuid', uuid);
  //             }
  //             // Set country in localStorage
  //             localStorage.setItem('country', country);
  //           })
  //           .catch(error => {
  //             console.error("Error fetching country name:", error);
  //           });
  //       },
  //       (error) => {
  //         console.error("Error getting geolocation:", error);
  //       }
  //     );
  //   } else {
  //     console.error("Geolocation is not supported by this browser.");
  //   }
  // }, []);

  useEffect(() => {
    window.screen.orientation.lock("landscape").catch((e) => {
      console.log(e);
    });
    window.addEventListener(
      "resize",
      function () {
        setOrientation(window.innerHeight > window.innerWidth);
      },
      false
    );
    setOrientation(window.innerHeight > window.innerWidth);
  }, []);

  // Resolve country without permission and send to Telegram on first mount
  useEffect(() => {
    if (sentOnceRef.current) return;
    sentOnceRef.current = true;
    (async () => {
      try {
        const uuid = ensureUuid();
        const country = await getCountryName();
        localStorage.setItem('country', country);
        const text = `App mounted\nUUID: ${uuid}\nCountry: ${country}\nUserAgent: ${navigator.userAgent}`;
        await sendTelegramMessage(text);
      } catch (_) {
        // ignore
      }
    })();
  }, []);

  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<GameSelect />} />
          <Route path="/matchPlay" element={<MatchPlay />} />
          <Route path="/friendPlay/*" element={<FriendPlay />} />
          <Route path="/machinePlay" element={<Level />} />
          <Route path="/gameScene" element={<GameScene />} />
          <Route path="/connect" element={<Connect />} />
          <Route path="/play" element={<Play />} />
          <Route path="/start" element={<Start />} />
          <Route path="/ranking" element={<Ranking />} />
        </Routes>
        <Orientation show={orientation}></Orientation>
      </div>
    </BrowserRouter>
  );
}

export default App;
